import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './Header.module.scss'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { ANALYTICS_SUPPORTED_PROVIDERS } from 'screens/Analytics/Analytics'
import { ExternalIntegrationSelect } from '../ExternalIntegrationSelect/ExternalIntegrationSelect'
import useURLParams from 'hooks/useURLParams'
import { useAnalyticsContext } from 'screens/Analytics/AnalyticsContext'
import { Text } from 'blaze-ui/Text/Text'
import { PeriodSelect } from '../PeriodSelect/PeriodSelect'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import dayjs from 'dayjs'
import { Calendar2, InformationCircleContained } from 'blaze-ui/icons'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { useIsVirtualMarketer } from 'hooks/useIsVirtualMarketer'

const TIME_PERIOD_TABS = ['overview']

const Extra = () => {
  // create label from last full week
  const startDate = dayjs().subtract(1, 'week').startOf('week').format('MMM DD, YYYY')
  const endDate = dayjs().subtract(1, 'week').endOf('week').format('MMM DD, YYYY')

  const label = `${startDate} - ${endDate}`

  return (
    <div className={Styles.extra}>
      <Calendar2 />
      <Text variant="placeholder" color="var(--dark-80)">
        {label}
      </Text>
      <Tooltip label="Due to Instagram API limitations, this data is delayed by 1 week">
        <div className={Styles.infoIcon}>
          <InformationCircleContained size={20} color="var(--dark-40)" />
        </div>
      </Tooltip>
    </div>
  )
}

export const Header = () => {
  const isNewHomeEnabled = useIsVirtualMarketer()
  const { data } = useExternalIntegrations()
  const [searchParams, setSearchParams] = useURLParams()
  const selectedIntegrationId = searchParams.get('external_integration_id')
  const tab = searchParams.get('tab')
  const { period, setPeriod } = useAnalyticsContext()
  const selectedIntegration = data?.external_integrations.find(
    (integration) => integration.id === parseInt(selectedIntegrationId || ''),
  )
  const supportedIntegrations =
    data?.external_integrations.filter((integration) =>
      ANALYTICS_SUPPORTED_PROVIDERS.includes(integration.provider as never),
    ) || []
  const hasValidIntegrations = supportedIntegrations.length > 0

  let timeSection

  if (TIME_PERIOD_TABS.includes(tab as string)) {
    timeSection = (
      <div className={Styles.headerRight}>
        <Text variant="secondary">Timeframe for all analytics</Text>
        <PeriodSelect variant="secondary" period={period} onPeriodChange={setPeriod} />
      </div>
    )
  } else if (selectedIntegration?.provider === ExternalIntegrationEnum.Instagram) {
    timeSection = (
      <div className={Styles.headerRight}>
        <Extra />
      </div>
    )
  }

  return (
    <>
      <div className={Styles.header}>
        <div className={Styles.headerInner}>
          <div className={Styles.headerLeft}>
            <Heading level={1}>Content Analytics</Heading>
            {hasValidIntegrations && !isNewHomeEnabled && (
              <ExternalIntegrationSelect
                selectedExternalIntegrationId={parseInt(selectedIntegrationId || '')}
                externalIntegrations={supportedIntegrations}
                onChange={(id) => setSearchParams({ external_integration_id: id.toString() })}
              />
            )}
          </div>
          {timeSection}
        </div>
      </div>
    </>
  )
}
